import type { AccessSchedule } from '@/models/channel';
import { AccessLevelType } from '@/models/channel';
import type { OU } from '@/models/Ou';

export interface AccessLevelOption {
  label: string;
  value: AccessLevelType;
}

export const DefaultAccessLevelOptions: AccessLevelOption[] = [
  { label: 'Free', value: AccessLevelType.Free },
  { label: 'Private', value: AccessLevelType.Private },
];

export const AllAccessLevelOptions: AccessLevelOption[] = [
  { label: 'Free', value: AccessLevelType.Free },
  { label: 'Paywall', value: AccessLevelType.Paywall },
  { label: 'Private', value: AccessLevelType.Private },
];

const accessUtils = {
  ensureExpireSet: (newAccessSchedules: AccessSchedule[], oldExpire: string, newExpire: string, force = false) => {
    const newSchedule: AccessSchedule = { from: newExpire, to: null, accessLevel: AccessLevelType.Private };
    if (oldExpire == null) {
      // we will need to create a new access schedule if newExpire is not null
      if (newExpire != null) {
        // console.log('inserting new access schedule at position 0', { newSchedule });
        newAccessSchedules.unshift(newSchedule);
      }
    } else {
      const foundIndex = newAccessSchedules.findIndex((x) => x.from === oldExpire);
      if (foundIndex > -1) {
        if (newExpire == null) {
          // remove the thing from the list
          newAccessSchedules.splice(foundIndex, 1);
        } else {
          // console.log('updating newAccessSchedules at ', foundIndex);
          newAccessSchedules[foundIndex] = newSchedule;
        }
      } else if (force) {
        // console.log('schedule not found, inserting new access schedule at position 0', { newSchedule });
        newAccessSchedules.unshift(newSchedule);
      }
    }
    return newAccessSchedules;
  },

  ensureEmbargoSet: (
    newAccessSchedules: AccessSchedule[],
    oldEmbargo: string,
    newEmbargo: string,
    force = false
  ): AccessSchedule[] => {
    const newSchedule: AccessSchedule = { from: null, to: newEmbargo, accessLevel: AccessLevelType.Private };
    if (oldEmbargo == null) {
      // we will need to create a new access schedule if newEmbargo is not null
      if (newEmbargo != null) {
        // console.log('inserting new access schedule at position 0', { newSchedule });
        newAccessSchedules.unshift(newSchedule);
      }
    } else {
      const foundIndex = newAccessSchedules.findIndex((x) => x.to === oldEmbargo);
      if (foundIndex > -1) {
        // console.log('updating newAccessSchedules at ', foundIndex);
        if (newEmbargo == null) {
          // remove the thing from the list
          newAccessSchedules.splice(foundIndex, 1);
        } else {
          newAccessSchedules[foundIndex] = newSchedule;
        }
      } else if (force) {
        // console.log('schedule not found, inserting new access schedule at position 0', { newSchedule });
        newAccessSchedules.unshift(newSchedule);
      }
    }
    return newAccessSchedules;
  },

  getAccessLevelOptions: (ouData: OU) => {
    if (ouData?.metaData?.enablePaywall === true) {
      return AllAccessLevelOptions;
    }
    return DefaultAccessLevelOptions;
  },
};

export { accessUtils };
